import { BFCM_SALE_TYPE } from 'modules/black-friday-cyber-monday/constants'
import { createSelector } from 'reselect'
import getSaleTypeBFCMSelect from 'modules/black-friday-cyber-monday/redux/selectors/get-sale-type'

const isCyberMondayBFCMSelect = createSelector(
  getSaleTypeBFCMSelect,
  saleType => saleType === BFCM_SALE_TYPE.CYBER_MONDAY
)

export default isCyberMondayBFCMSelect
